import { ReactNode } from "react";

import styled from "styled-components";

const Container = styled.div`
  flex: 1;
  width: 100%;
  padding: 0 20px 16px 16px;
  overflow-y: auto;
  order: 1;
`;

type Props = {
  children: ReactNode;
  className?: string;
};

export const Content = ({ children, className }: Props): JSX.Element => (
  <Container className={className}>{children}</Container>
);
